export enum apiListTypes {
  GET_API_LIST = '@@apiList/GET_API_LIST',
  GET_API_LIST_SUCCESS = 'apiList/GET_API_LIST_SUCCESS',
  GET_API_LIST_FAIL = 'apiList/GET_API_LIST_FAIL',

  ADD_API_LIST = '@@apiList/ADD_API_LIST',
  ADD_API_LIST_SUCCESS = '@@apiList/ADD_API_LIST_SUCCESS',
  ADD_API_LIST_FAIL = '@@apiList/ADD_API_LIST_FAIL',

  ADD_SUB_API = '@@apiList/ADD_SUB_API',
  ADD_SUB_API_SUCCESS = '@@apiList/ADD_SUB_API_SUCCESS',
  ADD_SUB_API_FAIL = '@@apiList/ADD_SUB_API_FAIL',

  UPDATE_SUB_API = '@@apiList/UPDATE_SUB_API',
  UPDATE_SUB_API_SUCCESS = '@@apiList/UPDATE_SUB_API_SUCCESS',
  UPDATE_SUB_API_FAIL = '@@apiList/UPDATE_SUB_API_FAIL',

  DELETE_SUB_API = '@@apiList/DELETE_SUB_API',
  DELETE_SUB_API_SUCCESS = '@@apiList/DELETE_SUB_API_SUCCESS',
  DELETE_SUB_API_FAIL = '@@apiList/DELETE_SUB_API_FAIL',

  DELETE_API_LIST = '@@apiList/DELETE_API_LIST',
  DELETE_API_LIST_SUCCESS = '@@apiList/DELETE_API_LIST_SUCCESS',
  DELETE_API_LIST_FAIL = '@@apiList/DELETE_API_LIST_FAIL',

  UPDATE_API_LIST = '@@apiList/UPDATE_API_LIST',
  UPDATE_API_LIST_SUCCESS = '@@apiList/UPDATE_API_LIST_SUCCESS',
  UPDATE_API_LIST_FAIL = '@@apiList/UPDATE_API_LIST_FAIL',

  TEST_API_LIST = '@@apiList/TEST_API_LIST',
  TEST_API_LIST_SUCCESS = '@@apiList/TEST_API_LIST_SUCCESS',
  TEST_API_LIST_FAIL = '@@apiList/TEST_API_LIST_FAIL',
  TEST_API_LIST_RESET = '@apiList/TEST_API_LIST_RESET',

  GET_LOCATION_SHOPIFY = '@@apiList/GET_LOCATION_SHOPIFY',
  GET_LOCATION_SHOPIFY_SUCCESS = '@@apiList/GET_LOCATION_SHOPIFY_SUCCESS',
  GET_LOCATION_SHOPIFY_FAIL = '@@apiList/GET_LOCATION_SHOPIFY_FAIL',
}
